import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDate, fullName, applicantLink } from '../../utils/configuredReportFormatters'

export const lrForm16Columns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'applicant_id',
    label: 'Applicant',
    sortKey: 'applicant_id',
    render: (row) => applicantLink(row.applicant_id ?? row.fk_applicant_id),
  },
  {
    id: 'name',
    label: 'Name',
    sortKey: 'name',
    render: (row) =>
      row.name
        ? display(row.name)
        : fullName(
            row.applicant_first_name ?? row.first_name,
            row.applicant_last_name ?? row.last_name,
          ),
  },
  {
    id: 'status',
    label: 'Status',
    sortKey: 'applicant_status',
    render: (row) => display(row.applicant_status ?? row.status),
  },
  {
    id: 'created_at',
    label: 'Date',
    sortKey: 'created_at',
    render: (row) => formatDate(row.created_at ?? row.date),
  },
]
